import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatDate, getFrequencyDays } from '../../../../utils/general';

interface Props {
  destinationIndex: number;
  saveStepper: ({ next }: any) => void;
  serviceIndex: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  setValues: React.Dispatch<React.SetStateAction<any>>;
  values: any;
}

const ServiceSummary: React.FC<Props> = function ServiceSummary({
  saveStepper,
  serviceIndex: index,
  setValues,
  setStep,
  values,
  destinationIndex
}) {
  const { t } = useTranslation();
  const theme = useTheme();

  const getIndividualTasks = (serviceTime: any, type: string) => {
    const { individualTasks } = serviceTime || {};

    if (
      type === 'services' &&
      individualTasks &&
      individualTasks.tasks &&
      individualTasks.tasks.length > 0
    ) {
      return `${individualTasks.tasks
        .map((task: any) => {
          return task.name;
        })
        .toString()
        .replaceAll(',', ', ')}`;
    }

    if (
      type !== 'services' &&
      individualTasks &&
      individualTasks?.tasks &&
      individualTasks?.tasks?.length > 0
    ) {
      return `${individualTasks.tasks
        .map((task: any) => {
          return task.name;
        })
        .toString()
        .replaceAll(',', ', ')}`;
    }

    return t('LEAD.CREATE.SERVICES.SUMMARY.noData');
  };

  const getServices = (serviceTime: any) => {
    if (
      serviceTime?.services &&
      serviceTime.id &&
      typeof serviceTime.id === 'number'
    ) {
      const { services: servicesByST } = serviceTime;
      if (servicesByST && servicesByST.length > 0) {
        return `${servicesByST
          .map((service: any) => {
            return service.name;
          })
          .toString()
          .replaceAll(',', ', ')}`;
      }
    }
    return t('LEAD.CREATE.SERVICES.SUMMARY.noData');
  };
  const auxKey = `schedule-serviceTime-${index}`;
  return (
    <Box key={`${auxKey}`}>
      <Box display="flex" justifyContent="space-between" width="100%">
        <Box
          display="grid"
          gridTemplateColumns="190px 170px 110px 1fr"
          sx={{ gridRowGap: '32px' }}
        >
          <Typography color="primary.main" variant="heading_300">
            {values.projectType !== 'Ad-Hoc'
              ? t('LEAD.CREATE.startDate')
              : 'Service Day'}
            :
          </Typography>

          <Typography color="mainText.300" variant="body_300">
            {formatDate(
              values?.destinations[destinationIndex]?.serviceTimes[index]
                .startDate
            )}
          </Typography>

          <Typography color="primary.main" variant="heading_300">
            {t('LEAD.CREATE.endDate')}:
          </Typography>

          <Typography color="mainText.300" variant="body_300">
            {formatDate(
              values?.destinations[destinationIndex]?.serviceTimes[index]
                .endDate
            )}
          </Typography>

          {/* Selected Days */}
          {values &&
          (values.projectType === 'adhoc' ||
            values.projectType === 'Ad-Hoc') ? null : (
            <>
              <Typography color="primary.main" variant="heading_300">
                {t('LEAD.CREATE.SERVICES.SelectedDays')}:
              </Typography>
              <Box
                gridColumn="span 3"
                style={{ fontSize: '16px', lineHeight: '20px' }}
              >
                <Typography color="mainText.300" variant="body_300">
                  {' '}
                  {values?.destinations[destinationIndex]?.serviceTimes
                    ? getFrequencyDays(
                        values?.destinations[destinationIndex]?.serviceTimes[
                          index
                        ]
                      )
                    : 'frequency'}
                </Typography>
              </Box>
            </>
          )}

          {/* Aditional Tasks */}
          <Typography color="primary.main" variant="heading_300">
            {t('LEAD.CREATE.SERVICES.SUMMARY.adhocTasks')}:
          </Typography>

          <Box
            gridColumn="span 3"
            style={{ fontSize: '16px', lineHeight: '20px' }}
          >
            <Typography color="mainText.300" variant="body_300">
              {values &&
              values.projectType !== 'adhoc' &&
              values.projectType !== 'Ad-Hoc'
                ? getIndividualTasks(
                    values?.destinations[destinationIndex]?.serviceTimes[index],
                    'services'
                  )
                : getIndividualTasks(
                    values?.destinations[destinationIndex]?.serviceTimes?.[
                      index
                    ],
                    'Ad-Hoc'
                  )}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ServiceSummary;
